import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../Controls/MessageHandler.component';
import {BlockComponent} from '../Controls/Block.component';
import { ActivityReasonEditComponent } from '../DomainDataEdit/ActivityReasonEdit.component';


@Component({
  selector: 'my-activityreason-grid',
  templateUrl: './ActivityReasonGrid.component.html'
})
export class ActivityReasonGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(ActivityReasonEditComponent) public activityReasonEditComponent: ActivityReasonEditComponent;
    records: ent.ActivityReason[];
    editedRecord: ent.ActivityReason = {};
    cols: any[];

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private domaindataService: serv.DomainDataService) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
        this.loadColumns();
        this.activityReasonEditComponent.requestTypeDropdownComponent.load();
        this.activityReasonEditComponent.equipmentClassDropdownComponent.load();
        this.activityReasonEditComponent.equipmentActivityDropdownComponent.load();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'Code', header: 'Code' },
            { field: 'Name', header: 'Name' },
            { field: 'RequestType.ID', header: 'Request Type ID' },
            { field: 'RequestType.Name', header: 'Request Type Name' },
            { field: 'EquipmentClass.ID', header: 'REquipment Class ID' },
            { field: 'EquipmentClass.Name', header: 'Equipment Class Name' },
            { field: 'EquipmentActivity.ID', header: 'Equipment Activity ID' },
            { field: 'EquipmentActivity.Name', header: 'Equipment Activity Name' },
            { field: 'Inactive', header: 'Inactive' },
        ];
    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        var filter: filters.ActivityReasonFilter = {IncludeInactive: true};
        this.domaindataService.getActivityReasons(filter).subscribe(x=> {
            this.records = x;
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }

    onAddClick(event: any){
        this.editedRecord = new ent.EquipmentTemplateRule();
        this.activityReasonEditComponent.requestTypeDropdownComponent.value = null;
        this.activityReasonEditComponent.equipmentClassDropdownComponent.value = null;
        this.activityReasonEditComponent.equipmentActivityDropdownComponent.value = null;
        this.activityReasonEditComponent.displayDialog = true;
    }

    onEditClick(event: any, record: ent.ActivityReason){
        
        this.editedRecord = record;
        
        this.activityReasonEditComponent.requestTypeDropdownComponent.value = this.editedRecord.RequestTypeID;
        this.activityReasonEditComponent.equipmentClassDropdownComponent.value = this.editedRecord.EquipmentClassID;
        this.activityReasonEditComponent.equipmentActivityDropdownComponent.value = this.editedRecord.EquipmentActivityID;
        this.activityReasonEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveActivityReasonRequest = {ActivityReason: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.domaindataService.saveActivityReason(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }
}